const buildConfig = {
    profile: process.env.VUE_APP_PROFILE || 'DEFAULT',
    name: process.env.VUE_APP_NAME || 'Siskeudes',
    version: process.env.VUE_APP_VERSION || 'v1.0.0-DEV',
    simplecaptcha: (process.env.VUE_APP_CAPTCHA || 'true')=='true',
    encryption: (process.env.VUE_APP_ENCRYPTION || 'false')=='true',
    disableRight: (process.env.VUE_APP_DISABLE_RIGHT || 'false')=='true',
    favicon: process.env.VUE_APP_FAVICON || 'favicon-default.ico',
    websiteInfo: JSON.parse(process.env.VUE_APP_WEBINFO || '{"linkWebsite": "","website": ""}'),
    geo: (process.env.VUE_APP_GEO || 'false')=='true',
};
export default {...buildConfig}